import { useState, useEffect, useRef } from 'react'
import { motion } from 'framer-motion'
import { Play, Pause, RotateCcw } from 'lucide-react'
import Button from './Button'

const MiniStopwatch = ({ onTimeChange, label = 'Vital Signs Timer' }) => {
  const [isRunning, setIsRunning] = useState(false)
  const [time, setTime] = useState(0)
  const intervalRef = useRef(null)

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        setTime((prev) => {
          const newTime = prev + 1
          if (onTimeChange) {
            onTimeChange(newTime)
          }
          return newTime
        })
      }, 1000)
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [isRunning, onTimeChange])

  const handleStart = () => {
    setIsRunning(true)
  }

  const handlePause = () => {
    setIsRunning(false)
  }

  const handleReset = () => {
    setIsRunning(false)
    setTime(0)
    if (onTimeChange) {
      onTimeChange(0)
    }
  }

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
  }

  return (
    <div className="p-4 rounded-xl bg-gradient-to-br from-primary-50 to-secondary-50 border-2 border-primary-200">
      <p className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">{label}</p>
      <div className="flex items-center justify-between">
        <motion.div
          className="text-2xl font-bold text-primary-700 font-mono"
          animate={isRunning ? { scale: [1, 1.1, 1] } : {}}
          transition={{ duration: 1.5, repeat: isRunning ? Infinity : 0 }}
        >
          {formatTime(time)}
        </motion.div>
        <div className="flex items-center gap-1">
          {!isRunning ? (
            <button
              onClick={handleStart}
              className="p-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition-colors"
            >
              <Play size={14} />
            </button>
          ) : (
            <button
              onClick={handlePause}
              className="p-2 rounded-lg bg-gray-400 text-white hover:bg-gray-500 transition-colors"
            >
              <Pause size={14} />
            </button>
          )}
          <button
            onClick={handleReset}
            className="p-2 rounded-lg bg-gray-300 text-gray-700 hover:bg-gray-400 transition-colors"
          >
            <RotateCcw size={14} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default MiniStopwatch

